import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import { Textarea } from "app/shadcnComponents/ui/textarea";
import { cn } from "app/lib/utils";

interface Props {
  searchValue: string;
  setSearchValue: (value: string) => void;
  disabled?: boolean;
  placeholder?: string;
}

export function DrawerSearchInput({
  searchValue,
  setSearchValue,
  disabled,
  placeholder = "Search...",
}: Readonly<Props>) {
  return (
    <div className="relative w-full">
      {!searchValue && (
        <FontAwesomeIcon
          icon={faMagnifyingGlass}
          className="absolute left-[16px] top-3 text-muted-foreground h-4 w-4"
        />
      )}
      <Textarea
        placeholder={placeholder}
        value={searchValue}
        onChange={(e) => setSearchValue(e.target.value)}
        disabled={disabled}
        className={cn(
          "min-h-[38px] h-[38px] resize-none placeholder:pl-[20px] placeholder:pt-[1px] no-scrollbar overflow-y-hidden"
        )}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
          }
        }}
      />
    </div>
  );
}
